import React from 'react';
import { connect } from 'react-redux';

import StartSafeTrade from './startSafeTrade.jsx';
import AgreementSentSummary from './agreement/summaries/agreementSentSummary.jsx';
import AgreementAcceptedSummary from './agreement/summaries/agreementAcceptedSummary.jsx';
import AgreementRejectedSummary from './agreement/summaries/agreementRejectedSummary.jsx';
import AgreementExpiredSummary from './agreement/summaries/agreementExpiredSummary.jsx';
import PaidSummary from './payment/summaries/paidSummary.jsx';
import PaymentRevertedSummary from './payment/summaries/paymentRevertedSummary.jsx';
import PaymentExpiredSummary from './payment/summaries/paymentExpiredSummary.jsx';
import ItemApprovedSummary from './payment/summaries/itemApprovedSummary.jsx';

import DiscountSuggestedSummary from './resolution/summaries/discountSuggestedSummary.jsx';
import DiscountApprovedSummary from './resolution/summaries/discountApprovedSummary.jsx';

import viewStatuses from '../viewStatus.js';
import { data as agreementDataPropTypes } from '../agreementPropTypes.js';
import partnerPropTypes from '../partnerPropTypes.js';
import { data as paymentDataPropTypes } from '../paymentPropTypes.js';
import { viewStatus as viewStatusPropType } from '../safeTradePropTypes.js';
import withdrawalPropTypes from '../withdrawalPropTypes.js';

const SafeTradeBuyerConversation = props => {
    const { viewStatus } = props;
    switch (viewStatus) {
        case viewStatuses.NOT_STARTED:
            return <StartSafeTrade {...props} />;
        case viewStatuses.AGREEMENT_SENT:
            return <AgreementSentSummary {...props} />;
        case viewStatuses.AGREEMENT_ACCEPTED:
            return <AgreementAcceptedSummary {...props} />;
        case viewStatuses.AGREEMENT_REJECTED:
            return <AgreementRejectedSummary {...props} />;
        case viewStatuses.AGREEMENT_EXPIRED:
            return <AgreementExpiredSummary {...props} />;
        case viewStatuses.PAID:
        case viewStatuses.PAYMENT_DELAYED:
            return <PaidSummary {...props} />;
        case viewStatuses.PAYMENT_REVERTED:
            return <PaymentRevertedSummary {...props} />;
        case viewStatuses.PAYMENT_EXPIRED:
            return <PaymentExpiredSummary {...props} />;
        case viewStatuses.ITEM_APPROVED:
            return <ItemApprovedSummary {...props} />;
        case viewStatuses.DISCOUNT_SUGGESTED:
            return <DiscountSuggestedSummary {...props} />;
        case viewStatuses.DISCOUNT_APPROVED:
            return <DiscountApprovedSummary {...props} />;
        default:
            return <div className="hidden">{status} er ikke håndtert</div>;
    }
};

SafeTradeBuyerConversation.propTypes = {
    agreement: agreementDataPropTypes,
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
    viewStatus: viewStatusPropType.isRequired,
    withdrawal: withdrawalPropTypes,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        partner: state.partner,
        payment: state.payment.data,
        viewStatus: state.safeTrade.viewStatus,
        withdrawal: state.withdrawal,
    };
}

export default connect(mapStateToProps)(SafeTradeBuyerConversation);



// WEBPACK FOOTER //
// ./safeTrade/buyer/safeTradeBuyerConversation.jsx